// @flow
import React from 'react';
import InfoBox from '../UI/InfoBox';

import '../../../static/scss/components/superUserBar.scss';

type Props = {
  user: ?Object
};

const SuperUserBar = ({ user }: Props) =>
  user && user.isSuperuser ? (
    <div className="c-su-bar">
      <InfoBox color="yellow" border>
        You are logged in as another user ({`${user.name}-#${user.id}`}).{' '}
        <strong>Please be careful. </strong>
        <a href="/admin/su/exit?next=%2Fdashboard%2Fbookings%2Fmade%2F">
          Click here
        </a>{' '}
        to return to your account or{' '}
        <a data-toggle="modal" href="/admin/su/">
          SU again.
        </a>
      </InfoBox>
    </div>
  ) : null;

export default SuperUserBar;
